export default __webpack_public_path__ + "static/char-s-47-zh-Hant-2a4b70ebf5b43312b5f15f8cad92915d.png";